import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CourseSetup from "SchoolSetup/routes/CourseSetup";

export default store => ({
  path: "course-setup",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "grade-levels" */ "./components/Classes"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [CourseSetup(store)],
});
